import { cn } from '@/lib/utils'

import { Badge, Button, CmdChip, Thumbnail } from '@/components/ui'

interface PaymentCardProps extends React.ComponentPropsWithoutRef<'div'> {
  card: any
  shortcut?: string | number
}

export const PaymentCard = ({
  card,
  shortcut,
  className,
  ...restProps
}: PaymentCardProps) => {
  return (
    <div
      className={cn(
        'flex gap-3 rounded-lg border border-gray-100 bg-white py-2 pl-1 pr-1 shadow-card hover:bg-gray-50 lg:py-1 dark:border-gray-700',
        className,
      )}
      {...restProps}
    >
      <Thumbnail
        size="xs"
        src={card?.logo_url}
        className="rounded-md !bg-white"
      />

      <div className="flex flex-grow flex-col justify-center gap-1 lg:flex-row lg:items-center lg:justify-start lg:gap-0">
        <span className="flex-grow text-sm font-medium">{card?.name}</span>
        <div className="flex flex-col gap-1 lg:flex-row lg:items-center lg:gap-2.5">
          <div className="flex items-center gap-1 lg:gap-2.5">
            {card?.discount &&
              card?.discount?.length > 0 &&
              card?.discount?.map((discount: any, index: number) => {
                return (
                  <Badge size="md" variant="discount" key={index}>
                    <span>
                      {discount?.discount_type === 'percentage'
                        ? `${discount?.discount}%`
                        : discount?.discount}
                    </span>
                    Discount
                  </Badge>
                )
              })}
          </div>

          <Button
            size="sm"
            variant="outline"
            className="hidden pr-1.5 lg:inline-flex"
          >
            <span>Select</span>
            <CmdChip hideIcon variant="dark" className="text-xs font-medium">
              {shortcut}
            </CmdChip>
          </Button>
        </div>
      </div>
    </div>
  )
}
